export default {
  'nav.home': 'Accueil',
  'nav.categories': 'Catégories',
  'nav.guides': 'Guides',
  'nav.safety': 'Sécurité',
  'nav.browse': 'Parcourir la boutique',
  'nav.shoppingGuide': "Guide d'achat",

  'hero.badge': 'Ressource indépendante · Mise à jour régulièrement',
  'hero.title': 'USFans Spreadsheet — Trouvez, organisez et explorez les ressources USFans',
  'hero.subtitle': 'Découvrez des créateurs, des catégories, des guides et des conseils de sécurité depuis un hub organisé. Parcourez la feuille de calcul USFans complète et achetez les dernières nouveautés.',
  'hero.ctaPrimary': 'USFans Spreadsheet',
  'hero.ctaSecondary': 'Acheter maintenant',
  'hero.trust': 'Informations organisées · Liens vérifiés · Navigation simple',

  'categories.title': 'Parcourir les catégories USFans',
  'categories.subtitle': 'Accédez directement à la catégorie que vous cherchez dans la feuille de calcul USFans.',
  'categories.dropdownLabel': 'Recherche rapide de catégorie',
  'categories.dropdownPlaceholder': 'Sélectionnez une catégorie',

  'cat.shoes': 'Chaussures',
  'cat.hoodies': 'Hoodies / Sweats',
  'cat.tshirts': 'T-shirts',
  'cat.jackets': 'Vestes',
  'cat.pants': 'Pantalons / Shorts',
  'cat.headwear': 'Couvre-chefs',
  'cat.sets': 'Ensembles',
  'cat.underwear': 'Sous-vêtements',
  'cat.jersey': 'Maillots',
  'cat.accessories': 'Accessoires',
  'cat.bags': 'Sacs',
  'cat.belts': 'Ceintures',
  'cat.perfumes': 'Parfums',
  'cat.other': 'Autres articles',

  'whatis.title': "Qu'est-ce que la USFans Spreadsheet ?",
  'whatis.p1': "La USFans Spreadsheet est une ressource organisée conçue pour vous aider à découvrir et à rechercher des informations liées à USFans en un seul endroit.",
  'whatis.p2': 'Au lieu de chercher dans des pages dispersées, vous pouvez explorer des catégories structurées, des informations sur les créateurs, des guides et des conseils de sécurité depuis un hub unique et pratique.',
  'whatis.p3': 'Explorez, comparez et vérifiez : tout ce dont vous avez besoin est rassemblé et trié pour une navigation plus rapide.',

  'value.title': 'Tout ce qu\'il vous faut pour explorer USFans en un seul endroit',
  'value.subtitle': 'Un hub unique et organisé avec les outils et les sujets les plus recherchés.',
  'value.item1': 'USFans Spreadsheet',
  'value.item2': 'Annuaire des créateurs',
  'value.item3': 'Guides de recherche et découverte',
  'value.item4': 'Avis et comparaisons',
  'value.item5': 'Informations sur la livraison',
  'value.item6': 'Ressources de coupons',
  'value.item7': 'Guides d\'entrepôt',
  'value.item8': 'Sécurité et protection',

  'popular.title': 'Recherches populaires USFans',
  'popular.subtitle': 'Explorez rapidement les sujets les plus recherchés.',
  'popular.review.title': 'Avis USFans',
  'popular.review.desc': 'Découvrez les fonctionnalités, l\'expérience utilisateur, les avantages et les points importants.',
  'popular.shipping.title': 'Frais de livraison USFans',
  'popular.shipping.desc': 'Comprenez les informations de livraison, les facteurs de prix et ce qui influence le coût total.',
  'popular.coupon.title': 'Coupon USFans',
  'popular.coupon.desc': 'Trouvez des informations sur les promotions, offres et ressources de coupons disponibles.',
  'popular.discount.title': 'Code promo USFans',
  'popular.discount.desc': 'Explorez les remises actuelles et apprenez à vérifier les offres promotionnelles.',
  'popular.warehouse.title': 'Entrepôt USFans',
  'popular.warehouse.desc': 'Découvrez comment fonctionnent les services et processus liés à l\'entrepôt.',
  'popular.legit.title': 'USFans est-il fiable ?',
  'popular.legit.desc': 'Comprenez comment évaluer la fiabilité, les signaux de confiance, la sécurité du site et les risques potentiels.',

  'comparison.title': 'Ressources USFans comparées',
  'comparison.subtitle': 'Un aperçu rapide de la façon dont chaque ressource vous aide à explorer USFans.',
  'comparison.col1': 'Ressource',
  'comparison.col2': 'Idéal pour',
  'comparison.col3': 'Organisation',
  'comparison.col4': 'Mises à jour',
  'comparison.col5': 'Pour débutants',
  'comparison.r1': 'USFans Spreadsheet',
  'comparison.r1best': 'Recherche organisée',
  'comparison.r2': 'Annuaire des créateurs',
  'comparison.r2best': 'Découvrir des créateurs',
  'comparison.r3': 'Guide de recherche',
  'comparison.r3best': 'Trouver des informations',
  'comparison.r4': 'Guide des avis',
  'comparison.r4best': 'Évaluer les options',

  'safety.title': 'Restez en sécurité en explorant les ressources USFans',
  'safety.p': 'Vérifiez toujours les liens avant de cliquer, évitez les pages de connexion suspectes, ne partagez jamais vos mots de passe, protégez vos informations personnelles et soyez prudent face aux téléchargements inconnus ou aux demandes de paiement.',
  'safety.link': 'Lire notre guide de sécurité',

  'articles.title': 'Guides et articles USFans',
  'articles.subtitle': 'Des ressources originales et complètes pour tirer le meilleur parti de la feuille de calcul USFans.',
  'articles.cardTitle': 'USFans Spreadsheet : Guide complet',
  'articles.cardDesc': 'Tout ce que vous devez savoir pour trouver, organiser et explorer les ressources USFans : catégories, conseils et sécurité.',
  'articles.readMore': 'Lire le guide',

  'final.title': 'Prêt à explorer la USFans Spreadsheet ?',
  'final.subtitle': 'Retrouvez des informations organisées, des guides utiles et les sujets USFans les plus recherchés depuis un hub central.',
  'final.cta': 'Explorer USFans Spreadsheet',

  'footer.tagline': 'Une ressource informative indépendante sur la feuille de calcul USFans et tout ce qui l\'entoure.',
  'footer.disclaimer': 'USFansLink.cfd est une ressource informative indépendante et n\'est pas affiliée ni approuvée par USFans, sauf mention explicite.',
  'footer.quickLinks': 'Liens rapides',
  'footer.resources': 'Ressources',
  'footer.copyright': 'Tous droits réservés.',
};